import { createFileRoute } from "@tanstack/react-router";
import { BookingDetailPage } from "@/features/bookings/pages/booking-detail-page/booking-detail-page";

export const Route = createFileRoute("/_authenticated/bookings/$bookingId")({
	component: BookingDetailPage,
});
